/* Returns true if the current document is inside an iframe */
export function isIFrame() {
  // eslint-disable-next-line no-restricted-properties
  return window.location !== window.parent.location
}
